const events = {
    listen(elem, name, handler) {
        // Did the user ask to listen to a list of events?
        if (typeof name === 'object' && name.length) {
            for (const n of name) {
                events.listen(elem, n, handler);
            }
        } else {
            elem.addEventListener(name, handler);
        }
    },

    ready() {
        return new Promise((resolve) => {
            if (
                document.readyState === 'complete' ||
                (document.readyState !== 'loading' &&
                    !document.documentElement.doScroll)
            ) {
                setTimeout(resolve);
            } else {
                document.addEventListener('DOMContentLoaded', resolve);
            }
        });
    },

    trigger(elem, name) {
        if (document.createEvent) {
            const e = document.createEvent('HTMLEvents');
            e.initEvent(name, true, false);
            elem.dispatchEvent(e);
        } else {
            elem.fireEvent('on' + name);
        }
    },

    unlisten(elem, name, handler) {
        // Did the user ask to unlisten to a list of events?
        if (typeof name == 'object' && name.length) {
            for (let n of name) {
                events.unlisten(elem, n, handler);
            }
        } else {
            elem.removeEventListener(name, handler);
        }
    },
};

export default events;
